/* eslint-disable */
import getModeReglement from '@/services/import/bailleur/parametrage/getModeReglement';
import getContratNature from '@/services/import/bail/parametrage/getContratNature';
import getSignataires from '@/services/import/bail/parametrage/getSignataires';
import getTauxTva from '@/services/import/bail/parametrage/getTauxTva';
import getBailleurs from '@/services/import/bail/parametrage/getBailleurs';
import getMateriels from '@/services/import/bail/parametrage/getMateriels';
import verificationTermePaiement from '@/services/import/bail/parametrage/verificationTermePaiement';
import genererBail from '@/services/import/bail/genererBail';
import { createAll } from '@/api/baux/contrat';
import i18n from '@/i18n';

export async function makeBailGenerated(lignes) {
  const lignesBaux = lignes[0];
  const lignesBailleurs = lignes[1];
  const lignesPatrimoines= lignes[2];
  await getModeReglement(lignesBaux.map((l => l.modeReglement)));
  await getContratNature(lignesBaux.map((l => l.natureBail)));
  await getSignataires(lignesBaux.map((l => l.signataire)));
  await getTauxTva(lignesBaux.map((l => l.tauxTva)));
  lignesBaux.forEach(l => {
    if (l.termePaiement && l.termePaiement.toString().trim().toUpperCase() == 'ECHOIR') {
      l.termePaiement = i18n.t('ajoutEditContrat.echeance.termePaiement.avance');
    }
  });
  verificationTermePaiement(lignesBaux.map((l => l.termePaiement)))

  const informationApiReference = {
    bailleurs: await getBailleurs(lignesBailleurs.map((l => l.codeBailleur))),
    materiels: await getMateriels(lignesPatrimoines.map((l => l.codeMateriel))),
  }
  const req = [];

  // génération bailleur
  [...new Set(lignesBaux)].forEach((ligneBail) => {
    const bailleursOfBail = [...new Set(lignesBailleurs.filter(ligneBailleur => ligneBailleur.codeBailLienBailleur.trim() === ligneBail.codeBail.trim()))];
    const materielsOfBail = [...new Set(lignesPatrimoines.filter(ligneMat => ligneMat.codeBailLienMateriel.trim() === ligneBail.codeBail.trim()))];
    req.push(genererBail(
      ligneBail,
      bailleursOfBail,
      materielsOfBail,
      informationApiReference
    ));
  });

  const results = await Promise.allSettled(req);
  const baux = results.map(el => el.value);
  const errors = results.filter((result) => result.status === 'rejected');
  if (errors.length > 0) throw errors.map(e => e.reason.response);
  else return baux.filter(bail => bail.contratsMateriels.length > 0);
}

export async function makeBailImport(baux, modeTest) {
  const params = {
    contrats: baux,
    modeTest: modeTest,
    compteurError: true,
  }
  await createAll(params);
}
